export default __webpack_public_path__ + "static/N0209-414e4c66d760b0357c2d49e0f3c9e69d.png";